// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Xg2L","colBig":"styles_colBig__1vAnl","colSmall":"styles_colSmall__2iBwS","shopifyNameWrapper":"styles_shopifyNameWrapper__3lUKC"};